import { nanoid } from 'nanoid'
import {
  AKEEL,
  ALETSON,
  ATRUFELLMAN,
  BENTZMINGER,
  BGIAEVER,
  CBANNON,
  CDMONTEBELLO,
  CKRIMITSOS,
  CVINCENT,
  EBOITEIN,
  HLEIVA,
  IGLASS,
  JBRUDER,
  JDELORE,
  JSESSLER,
  JSUBRIN,
  LANWAR,
  LOO,
  MLOBEL,
  NQUAH,
  OEISENBERG,
  PSDOLMAN,
  RWALCH,
  SNEWMAN,
  SRUST,
  TKAY,
  TKS,
  VGELLER,
  VLANG,
  VWILLIAMS,
  WDORR,
  WPEARSON,
  ZSAUNDERS,
  MTAN,
  EEDDINGS,
  LABRAMS,
  KBISHOP,
  KGIVEN,
  NHILL,
  ICOSS,
  LDAY,
  MMCCUNE,
  BRISKIN,
  DBOULANGE,
  NDELTORO,
  LPASSELL,
  DCHIVVIS,
  JGONZALES,
  DANMISENER,
  RONALDYOUNGJR
} from '../../assets/guests'
import { GuestData } from './types';

export const GUESTS_DATA: GuestData[] = [
  {
    id: nanoid(),
    name: 'Al Letson',
    title: 'Host of Reveal (PRX)',
    image: ALETSON,
    jobType: 'Host',
  },
  {
    id: nanoid(),
    name: 'Latinos Out Loud',
    title: 'Hosts of Latinos Out Loud',
    image: LOO,
    jobType: 'Host',
  },
  {
    id: nanoid(),
    name: 'Veralyn Williams',
    title: 'EP, The United States of Anxiety (WNYC)',
    image: VWILLIAMS,
    jobType: 'Executive Producer',
  },
  {
    id: nanoid(),
    name: 'Ira Glass',
    title: 'Executive Producer & Host, This American Life',
    image: IGLASS,
    jobType: 'Host',
  },
  {
    id: nanoid(),
    name: 'Nick Quah',
    title: 'Founder & Editor, Hot Pod Newsletter',
    image: NQUAH,
    jobType: 'Founder',
  },
  {
    id: nanoid(),
    name: 'Avery Trufelman',
    title: 'Host of The Cut and Nice Try! (Vox Media)',
    image: ATRUFELLMAN,
    jobType: 'Host',
  },
  {
    id: nanoid(),
    name: 'Chris Bannon',
    title: 'Chief Content Officer, Stitcher',
    image: CBANNON,
    jobType: 'Executive',
  },
  {
    id: nanoid(),
    name: 'Nikki Silva',
    title: 'Co-Executive Producer, The Kitchen Sisters',
    image: TKS,
    jobType: 'Producer',
  },
  {
    id: nanoid(),
    name: 'Chris Krimitsos',
    title: 'Founder/Chief Creative Officer, PodFest',
    image: CKRIMITSOS,
    jobType: 'Founder',
  },
  {
    id: nanoid(),
    name: 'Zoe Saunders',
    title: 'Senior Producer, Original Series, CNN Audio',
    image: ZSAUNDERS,
    jobType: 'Producer',
  },
  {
    id: nanoid(),
    name: 'Ophira Eisenberg',
    title: 'Host of Ask Me Another (NPR)',
    image: OEISENBERG,
    jobType: 'Host',
  },
  {
    id: nanoid(),
    name: 'Emily Botein',
    title: 'VP, Original Programming, WNYC Studios',
    image: EBOITEIN,
    jobType: 'Executive',
  },
  {
    id: nanoid(),
    name: 'Julie Subrin',
    title: 'Independent Producer & Editor',
    image: JSUBRIN,
    jobType: 'Producer',
  },
  {
    id: nanoid(),
    name: 'Wendy Dorr',
    title: 'Executive Producer, New York Times Audio',
    image: WDORR,
    jobType: 'Executive Producer',
  },
  {
    id: nanoid(),
    name: 'Mia Lobel',
    title: 'Executive Producer, Pushkin Industries',
    image: MLOBEL,
    jobType: 'Executive Producer',
  },
  {
    id: nanoid(),
    name: 'Abigail Keel',
    title: 'Senior Producer, Stitcher',
    image: AKEEL,
    jobType: 'Producer',
  },
  {
    id: nanoid(),
    name: 'Liyna Anwar',
    title: 'Producer, StoryCorps',
    image: LANWAR,
    jobType: 'Producer',
  },
  {
    id: nanoid(),
    name: 'John Delore',
    title: 'Senior Editor, Stitcher',
    image: JDELORE,
    jobType: 'Editor',
  },
  {
    id: nanoid(),
    name: 'Valerie Geller',
    title: 'Consultant, Geller Media International',
    image: VGELLER,
    jobType: 'Consultant',
  },
  {
    id: nanoid(),
    name: 'Scott Newman',
    title: 'Founder & Creative Director, On Air Fest',
    image: SNEWMAN,
    jobType: 'Founder',
  },
  {
    id: nanoid(),
    name: 'Charles De Montebello',
    title: 'Owner & Engineer, CDM Sound Studios',
    image: CDMONTEBELLO,
    jobType: 'Owner',
  },
  {
    id: nanoid(),
    name: 'Trey Kay',
    title: 'Host & Producer, Us & Them',
    image: TKAY,
    jobType: 'Host',
  },
  {
    id: nanoid(),
    name: 'Victoria Lang',
    title: 'Producer, Found',
    image: VLANG,
    jobType: 'Producer',
  },
  {
    id: nanoid(),
    name: 'Jared Bruder',
    title: 'Director of Brand Marketing, The Dandy Group',
    image: JBRUDER,
    jobType: 'Director',
  },
  {
    id: nanoid(),
    name: 'Joshua Sessler',
    title: 'Law Partner, Cowan DeBaets Abrahams & Sheppard',
    image: JSESSLER,
    jobType: 'Legal',
  },
  {
    id: nanoid(),
    name: 'Hendel Leiva',
    title: 'Host & Producer, Immigration MIC Podcast',
    image: HLEIVA,
    jobType: 'Host',
  },
  {
    id: nanoid(),
    name: 'Rob Walch',
    title: 'VP, Podcaster Relations Libsyn',
    image: RWALCH,
    jobType: 'Executive',
  },
  {
    id: nanoid(),
    name: 'Bryan Entzminger',
    title: 'Engineer/Editor, Top Tier Audio',
    image: BENTZMINGER,
    jobType: 'Editor',
  },
  {
    id: nanoid(),
    name: 'Bianca Giaever',
    title: 'Producer, New York Times Audio',
    image: BGIAEVER,
    jobType: 'Producer',
  },
  {
    id: nanoid(),
    name: 'Cher Vincent',
    title: 'Senior Producer, Pushkin Industries',
    image: CVINCENT,
    jobType: 'Producer',
  },
  {
    id: nanoid(),
    name: 'Paul Samuel Dolman',
    title: 'Host of What Matters Most',
    image: PSDOLMAN,
    jobType: 'Host',
  },
  {
    id: nanoid(),
    name: 'Suzanne Rust',
    title: 'Senior Curatorial Producer, The Moth',
    image: SRUST,
    jobType: 'Producer',
  },
  {
    id: nanoid(),
    name: 'Will Pearson',
    title: 'Chief Operations Officer, iHeart Podcast Network',
    image: WPEARSON,
    jobType: 'Executive',
  },
  {
    id: nanoid(),
    name: 'Megan Tan',
    title: 'Senior Producer, LAist Studios',
    image: MTAN,
    jobType: 'Producer',
  },
  {
    id: nanoid(),
    name: 'Eric Eddings',
    title: 'Director, Stitcher, For Colored Nerds',
    image: EEDDINGS,
    jobType: 'Director',
  },
  {
    id: nanoid(),
    name: 'Lindsay Abrams',
    title: 'Leading Design Strategist, CNN Podcasts & Audio',
    image: LABRAMS,
    jobType: 'Designer',
  },
  {
    id: nanoid(),
    name: 'Katie Bishop',
    title: 'Executive Producer, Death, Sex & Money',
    image: KBISHOP,
    jobType: 'Executive Producer',
  },
  {
    id: nanoid(),
    name: 'Karen Given',
    title: 'Founder, Narrative Beat',
    image: KGIVEN,
    jobType: 'Founder',
  },
  {
    id: nanoid(),
    name: 'Nichole Hill',
    title: 'Host, Secret Adventures of Black People',
    image: NHILL,
    jobType: 'Host',
  },
  {
    id: nanoid(),
    name: 'Ian Coss',
    title: 'Host, Forever is a Long Time',
    image: ICOSS,
    jobType: 'Host',
  },
  {
    id: nanoid(),
    name: 'Leila Day',
    title: 'Host, The Stoop Berry from Podcasts in Color',
    image: LDAY,
    jobType: 'Host',
  },
  {
    id: nanoid(),
    name: 'Marianne McCune',
    title: 'Reporter, Narrative Unit, The United States of Anxiety',
    image: MMCCUNE,
    jobType: 'Reporter',
  },
  {
    id: nanoid(),
    name: 'Benjamin Riskin',
    title: 'Founder, Room Tone',
    image: BRISKIN,
    jobType: 'Founder',
  },
  {
    id: nanoid(),
    name: 'Deb Boulange',
    title: 'CEO, The Great Do-Over',
    image: DBOULANGE,
    jobType: 'Executive',
  },
  {
    id: nanoid(),
    name: 'Natasha Del Toro',
    title: 'Host, Verified',
    image: NDELTORO,
    jobType: 'Host',
  },
  {
    id: nanoid(),
    name: 'Lauren Passell',
    title: 'Founder, Tink Media',
    image: LPASSELL,
    jobType: 'Founder',
  },
  {
    id: nanoid(),
    name: 'Dana Chivvis',
    title: 'Executive Producer, This American Life / Serial',
    image: DCHIVVIS,
    jobType: 'Executive Producer',
  },
  {
    id: nanoid(),
    name: 'Jocelyn Gonzales',
    title: 'Director, PRX Productions',
    image: JGONZALES,
    jobType: 'Director',
  },  
  {
    id: nanoid(),
    name: 'Dan Misener',
    title: 'Co-Founder of Bumper',
    image: DANMISENER,
    jobType: 'Founder',
  },
  {
    id: nanoid(),
    name: 'Ronald Young Jr.',
    title: 'Creator and Host of "Weight for It"',
    image: RONALDYOUNGJR,
    jobType: 'Host',
  },
]
